import { render, staticRenderFns } from "./SearchModal.vue?vue&type=template&id=7af4c645&scoped=true"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"
import style0 from "./SearchModal.vue?vue&type=style&index=0&id=7af4c645&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af4c645",
  null
  
)


    import installComponents from "!/home/gitlab-runner/builds/_LQxgyuP/0/skolkovo/frontend/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BIconMicFill, BButton, BFormInput, BInputGroupAppend, BInputGroup, BIconSearch, BFormGroup, BForm, BOverlay, BModal} from 'bootstrap-vue'
    installComponents(component, {BIconMicFill, BButton, BFormInput, BInputGroupAppend, BInputGroup, BIconSearch, BFormGroup, BForm, BOverlay, BModal})
    

export default component.exports